export default __webpack_public_path__ + "static/media/document.c141bb18.jpg";